import { render } from "./ContactView.vue?vue&type=template&id=44289899"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=44289899&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__